import {
  GET_OPERATIONS,
  GET_OPERATIONS_SUCCESS,
  GET_OPERATIONS_FAILURE,
  GET_OPERATION,
  GET_OPERATION_SUCCESS,
  GET_OPERATION_FAILURE
} from './operationsActions';

const initialState = {
  customerOperations: [],
  customerOperation: {},
  numberOfOperations: 0,
  loading: true,
  loadingOperation: true
};

/**
 * Réducer de la partie des opeartions
 */
const operationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OPERATION:
      return {
        ...state,
        customerOperation: {},
        loadingOperation: true
      };
    case GET_OPERATION_SUCCESS:
      return {
        ...state,
        customerOperation: action.payload.customerOperation,
        loadingOperation: false
      };
    case GET_OPERATION_FAILURE:
      return {
        ...state,
        loadingOperation: false
      };
    case GET_OPERATIONS:
      return {
        ...state,
        customerOperations: [],
        loading: true
      };
    case GET_OPERATIONS_SUCCESS:
      return {
        ...state,
        customerOperations: action.payload.customerOperations,
        numberOfOperations: action.payload.total,
        loading: false
      };
    case GET_OPERATIONS_FAILURE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default operationsReducer;
